import { createSelector } from 'helpers/reselect'

const getPromotionExpirationStatus = state => state.promotionExpirationStatus

export const getPromotionDetailsList = createSelector(
  [getPromotionExpirationStatus],
  ({
    promotionDetailsList = []
  } = {}) => promotionDetailsList
)

export const getAppointmentDatesNotInRangeOfPromoDates = createSelector(
  [getPromotionExpirationStatus],
  ({
    appointmentDatesNotInRangeOfPromoDates = []
  } = {}) => appointmentDatesNotInRangeOfPromoDates
)

export const getShowCallStorePromoExpirationNotification = createSelector(
  [getPromotionExpirationStatus],
  ({
    showCallStorePromoExpirationNotification = []
  } = {}) => showCallStorePromoExpirationNotification
)

export const getShowInRangePromoExpirationNotification = createSelector(
  [getPromotionExpirationStatus],
  ({
    showInRangePromoExpirationNotification = []
  } = {}) => showInRangePromoExpirationNotification
)

export const getPromoExpirationModalWasShown = createSelector(
  [getPromotionExpirationStatus],
  ({
    modalWasShown = false
  } = {}) => modalWasShown
)
